export const IncidentsConstants = {
  LIST_ELEMENTS: ['blockedIncidents', 'investigatingIncidents', 'partiallyBlockedIncidents'],
};
